var map = {
	"./es.json": [
		7995,
		117
	],
	"./fr.json": [
		6115,
		115
	],
	"./games/calamite/calamite-es.json": [
		3492,
		492
	],
	"./games/calamite/calamite-fr.json": [
		6139,
		139
	],
	"./games/calamite/calamite-id.json": [
		1377,
		377
	],
	"./games/calamite/calamite-ru.json": [
		7837,
		837
	],
	"./games/calamite/calamite-us.json": [
		5283,
		283
	],
	"./games/classic-blackjack/classic-blackjack-es.json": [
		3972,
		972
	],
	"./games/classic-blackjack/classic-blackjack-fr.json": [
		709,
		709
	],
	"./games/classic-blackjack/classic-blackjack-id.json": [
		6780,
		780
	],
	"./games/classic-blackjack/classic-blackjack-ru.json": [
		4665,
		665
	],
	"./games/classic-blackjack/classic-blackjack-us.json": [
		5410,
		410
	],
	"./games/drawing-battle/drawing-battle-es.json": [
		3802,
		802
	],
	"./games/drawing-battle/drawing-battle-fr.json": [
		6683,
		683
	],
	"./games/drawing-battle/drawing-battle-pt.json": [
		8923,
		923
	],
	"./games/drawing-battle/drawing-battle-ru.json": [
		2808,
		808
	],
	"./games/drawing-battle/drawing-battle-us.json": [
		2713,
		713
	],
	"./games/novice-artists/novice-artists-fr.json": [
		5899,
		899
	],
	"./games/novice-artists/novice-artists-ru.json": [
		8495,
		495
	],
	"./games/novice-artists/novice-artists-us.json": [
		9263,
		263
	],
	"./games/poker/poker-es.json": [
		298,
		298
	],
	"./games/poker/poker-fr.json": [
		6420,
		420
	],
	"./games/poker/poker-id.json": [
		5231,
		231
	],
	"./games/poker/poker-ru.json": [
		177,
		177
	],
	"./games/poker/poker-us.json": [
		1074,
		74
	],
	"./id.json": [
		6235,
		235
	],
	"./ru.json": [
		482,
		482
	],
	"./us.json": [
		4621,
		621
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 5407;
module.exports = webpackAsyncContext;